import { z } from 'zod';

/**
 * What a reviewer sends with a verdict on a recorded collision.
 *
 * **The verdict is the route, not a field.** `POST …/confirm` bans;
 * `POST …/dismiss` clears the pair. A `resolution` in the body would make one
 * request expressible two ways, and on the one endpoint in the portal that ends
 * an account, `/confirm` with `{resolution: 'dismissed'}` is a question with no
 * correct answer.
 *
 * The note is the reviewer's own, staff-facing, and optional: a dismissal is
 * often self-evident from the two accounts. A **blank** note normalizes to
 * `null` rather than to `''`, because an empty quotation rendered under "the
 * reviewer said" reads as a redaction instead of as an absence.
 */
export const ReviewMatchSchema = z
  .object({
    note: z
      .string()
      .trim()
      .max(2000)
      .nullable()
      .default(null)
      .transform((note) => (note === null || note === '' ? null : note)),
  })
  .strict();

export type ReviewMatchRequest = z.infer<typeof ReviewMatchSchema>;
